<template>
<div class="popup" v-cloak v-if="show">
    <div class="content" id="errorPopup">
        <div class="title">
            {{title}}
        </div>
        <div class="error-body">
            <span>{{message}}</span>
        </div>
        <div class="task-footer">
            <button class="task-button" @click="closePage()">{{$t('language.common.ok')}}</button>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data: function () {
        return {
            title: "",
            message: "",
            show: false,
        }
    },
    methods: {
        //关闭弹窗
        closePage() {
            this.show = false;
        }
    }
}
</script>

<style>
#errorPopup {
    width: 400px;
    /*no*/
    height: 180px;
    /*no*/
}

#errorPopup .error-body {
    height: calc(100% - 130px);/*no*/
    margin: 20px;/*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/common/error_popup.vue